var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-view"},[(_vm.loaded)?_c('HubProfile',{attrs:{"name":"profile"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }